import React from 'react';
import TransitionRoot, {getTransitionDuration, TransitionRootProps, TransitionTimeout} from './TransitionRoot';

const getDefaultStyle = (timeout: TransitionTimeout): React.CSSProperties => ({
  transition: `opacity ${getTransitionDuration(timeout, 'enter')}ms ease-in-out`,
});

const getTransitionStyles = (timeout: TransitionTimeout): {[name: string]: React.CSSProperties} => {
  return {
    entering: {
      transitionDuration: getTransitionDuration(timeout, 'enter').toString(),
      opacity: 0,
    },
    entered: {
      opacity: 1,
      transitionDuration: getTransitionDuration(timeout, 'enter').toString(),
    },
    exiting: {
      opacity: 0,
      transitionDuration: getTransitionDuration(timeout, 'exit').toString(),
    },
    exited: {
      opacity: 0,
      transitionDuration: getTransitionDuration(timeout, 'exit').toString(),
    },
  };
};

export type FadeProps = TransitionRootProps;

export const Fade: React.FC<FadeProps> = ({children, timeout, in: inProp, nodeRef: nodeRefProp, ...restProps}) => {
  const rootRef = React.useRef(null);
  const nodeRef = nodeRefProp || rootRef;

  const getChildrenWithProps = (state) => {
    return React.Children.map(children, (child: React.ReactNode) => {
      if (React.isValidElement(child)) {
        return React.cloneElement<any>(child, {
          ref: nodeRef,
          style: {
            ...getDefaultStyle(timeout),
            ...getTransitionStyles(timeout)[state],
            ...child?.props?.style,
          },
        });
      }
      return child;
    });
  };

  return (
    <TransitionRoot nodeRef={nodeRef} appear={inProp} in={inProp} timeout={timeout} {...restProps}>
      {(state) => getChildrenWithProps(state)}
    </TransitionRoot>
  );
};

export default Fade;
